import * as moment from 'moment';

export class Constants {
    public SessionTimeOut: number = 300;
    public messageType: any;
    public videoStatus: any;

    constructor() {
        this.messageType = {
            Success: '2',
            Error: '1',
            Warning: '3',
            RequestExist: '7'
        }


        this.videoStatus = {
            Draft: '1',
            Previewed: '2'
        }
    }
}   